'use client'

import { useLenis } from '@/providers/LenisProvider'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export const ScrollToTop: React.FC = () => {
  const { lenis } = useLenis()
  const pathname = usePathname()

  useEffect(() => {
    // Scroll to top when route changes
    if (lenis) {
      lenis.scrollTo(0, { duration: 0 }) // Instant scroll to top
    } else {
      // Fallback for when Lenis isn't ready
      window.scrollTo(0, 0)
    }
  }, [pathname, lenis])

  return null
}
